import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';

export const errorInterceptorFn: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((error) => {
      if (error.error) {
        const errorString = Object.entries(error.error)
          .map(([key, value]) => `${key}: ${value}`)
          .join('\n');

        messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: errorString
        });
      } else {
        const errorMessage = error.error.message || 'Wystąpił błąd podczas wykonywania operacji';

        messageService.add({
          severity: 'error',
          summary: `Error: ${error.status}`,
          detail: errorMessage
        });
      }

      return throwError(() => error);
    })
  );
};
